namespace RioERP.Web.Enums {
    export enum EmailEvent {
        CustomerOrderPlaced = 1,
        FranchiseeOrderPlaced = 2,
        CustomerOrderProcessed = 3,
        CustomerOrderShipped = 4,
        Cancelled = 5,
        CustomerOrderDelivered = 6,
        NewBrandAmbassador = 7,
        BrandAmbassadorCouponCode = 8,
        BrandAmbassadorOrder = 9,
        BrandAmbassadorMonthlysummary = 10,
        BrandAmbassadorSettlement = 11,
        InvoiceAttachment = 12,
        FranchiseeAccountCreated = 13,
        TeacherAccountCreated = 14
    }
    Serenity.Decorators.registerEnumType(EmailEvent, 'RioERP.Web.Enums.EmailEvent');
}
